/**
 * @file
 * @author zhousheng
 */
import InternalCheckbox from './Checkbox';
import ButtonCheckbox from './ButtonCheckbox';
import Group from './Group';
export { CheckboxProps, CheckboxChangeEvent } from './Checkbox';
export { CheckboxGroupProps, CheckboxOptionType } from './Group';
const Checkbox = InternalCheckbox;
Checkbox.Group = Group;
Checkbox.Button = ButtonCheckbox;
Checkbox.__ACUD_CHECKBOX = true;
export default Checkbox;
